/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TripForwardingRelationship } from './TripForwardingRelationship';
import {
    TripForwardingRelationshipFromJSON,
    TripForwardingRelationshipFromJSONTyped,
    TripForwardingRelationshipToJSON,
    TripForwardingRelationshipToJSONTyped,
} from './TripForwardingRelationship';

/**
 * 
 * @export
 * @interface TripForwardingRelationshipResponse
 */
export interface TripForwardingRelationshipResponse {
    /**
     * 
     * @type {Array<TripForwardingRelationship>}
     * @memberof TripForwardingRelationshipResponse
     */
    relationships: Array<TripForwardingRelationship>;
}

/**
 * Check if a given object implements the TripForwardingRelationshipResponse interface.
 */
export function instanceOfTripForwardingRelationshipResponse(value: object): value is TripForwardingRelationshipResponse {
    if (!('relationships' in value) || value['relationships'] === undefined) return false;
    return true;
}

export function TripForwardingRelationshipResponseFromJSON(json: any): TripForwardingRelationshipResponse {
    return TripForwardingRelationshipResponseFromJSONTyped(json, false);
}

export function TripForwardingRelationshipResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripForwardingRelationshipResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'relationships': ((json['relationships'] as Array<any>).map(TripForwardingRelationshipFromJSON)),
    };
}

export function TripForwardingRelationshipResponseToJSON(json: any): TripForwardingRelationshipResponse {
    return TripForwardingRelationshipResponseToJSONTyped(json, false);
}

export function TripForwardingRelationshipResponseToJSONTyped(value?: TripForwardingRelationshipResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationships': ((value['relationships'] as Array<any>).map(TripForwardingRelationshipToJSON)),
    };
}

